import { jsx as i } from "react/jsx-runtime";
import { NextResponse as s } from "next/server";
import { getUserInfoFromHeaders as n, getTrackerId as a } from "./helpers.js";
import { WebPrismeLogger as p, augmentTrackingHeaders as u } from "@bytel/logger-web";
import { Debug as d } from "@bytel/logger-core";
import { PrismeProvider as m } from "./client.js";
const c = d("logger:next-server");
class T extends p {
  constructor(r) {
    r.urlEndpoint = r.urlEndpoint ?? r.serverUrlEndpoint, super(r);
  }
  async log(r, e) {
    const o = {
      ...n(),
      trackerId: await a()
    };
    super.log(r, e, o);
  }
  async error(...r) {
    const e = {
      ...r[1] ?? {},
      ...n(),
      trackerId: await a()
    };
    super.error(r[0], e);
  }
}
const v = async ({
  children: t,
  config: r
}) => {
  const e = await a(), o = n();
  return c("in NextPrismeProvider", { trackerIdFromCookie: e, config: r }), /* @__PURE__ */ i(
    m,
    {
      trackerId: e,
      userInfos: o,
      config: r,
      children: t
    }
  );
}, x = () => ({
  POST: async (t) => {
    const r = await t.json();
    return c(JSON.stringify(r)), s.json({ status: "ok" }, { status: 200 });
  }
}), k = () => ({
  POST: async (t) => {
    const r = await t.json();
    try {
      const e = process.env.ST ?? process.env.NEXT_PUBLIC_ST;
      if (!process.env.LOG_API_ENDPOINT || !e)
        throw new Error(
          "`st` and `endpoint` are mandatory to create the logging route"
        );
      return await fetch(process.env.LOG_API_ENDPOINT, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...u(e, crypto.randomUUID())
        },
        body: JSON.stringify(r)
      }), s.json({ status: "ok" }, { status: 200 });
    } catch (e) {
      return console.log(e), s.json({ status: "server error" }, { status: 500 });
    }
  }
});
export {
  T as NextPrismeLogger,
  v as NextPrismeProvider,
  x as createRouteForConsole,
  k as createRouteForLogApi,
  a as getTrackerId
};
//# sourceMappingURL=server.js.map
